import ComponentUtils from "../../../ComponentUtils";

export default function runChildren(props, {hover, focus}) {
	props.children = ComponentUtils.executeFunctionChildren(props.children, {hover, focus});
}
